import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ARService } from '../../ar/ar.service';
import { ArPaymentInvoiceGeneratorComponent } from '../../ar/payment/ar-payment-invoice-generator/ar-payment-invoice-generator.component';
import { PatientService } from '../../patient/patient.service';

@Component({
  standalone: false,
  selector: 'app-patient-portal-payments',
  templateUrl: './patient-portal-payments.component.html',
  styleUrls: ['./patient-portal-payments.component.css']
})
export class PatientPortalPaymentsComponent implements OnInit {

  isLoading: boolean = false;

  patientInformation: any;
  PatientId: string;
  dataPatient: any;

  dataPayments: any[] = [];

  constructor(
    private arService: ARService,
    private patientService: PatientService,
    private dialog: MatDialog,
  ) {
    this.patientInformation = JSON.parse(localStorage.getItem('storedPatient'));
    this.PatientId = this.patientInformation.authdata.userid;
  }

  ngOnInit() {
    this.init();   
  }


  init() {
    this.isLoading = true;

    let promises = [
      this.getPaymentsForPatient(),
      this.getPatient(this.PatientId),
      this.getLOCIDForPayments(),
    ];

    Promise.all(promises).then((results: any[]) => {

      var payments = results[0];
      var dataPatient = results[1];
      var locidMap = results[2];

      this.dataPayments = [];

      payments.forEach(payment => {
        try {
          var invoiceObj = JSON.parse(payment.PaymentInvoiceObject);
          if (invoiceObj.showInvoice) {

            if (invoiceObj.invoiceIsPaid === null || typeof invoiceObj.invoiceIsPaid == "undefined") {
              invoiceObj.invoiceIsPaid = true;
            }

            payment.DATA_INVOICE_OBJECT = invoiceObj;

            var locidObj = locidMap.find(locObj => {
              return locObj.PaymentID === payment.PaymetnID;
            });

            payment.LOCID = locidObj ? locidObj.LOCID : 0;

            this.dataPayments.push(payment);
          }
        } catch (e) {

        }
      });

      this.dataPayments = this.dataPayments.sort((a, b) => {
        var d1 = new Date(a.DATA_INVOICE_OBJECT.invoiceDate);
        var d2 = new Date(b.DATA_INVOICE_OBJECT.invoiceDate);
        return d2.getTime() - d1.getTime();
      });

      this.dataPatient = dataPatient;

      this.isLoading = false;

    }, err => {
      this.isLoading = false;
    });
  }


  getLOCIDForPayments() {
    let promise = new Promise((resolve, reject) => {
      this.arService.getLOCIDForPayments(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getPatient(patientId: string) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.getPatient(patientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getPaymentsForPatient() {
    let promise = new Promise((resolve, reject) => {
      this.arService.getPaymentsForPatient(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  openInvoice(paymentObj) {

    console.log('OPEN INVOICE FOR ', paymentObj);

    const dialogRef = this.dialog.open(ArPaymentInvoiceGeneratorComponent, {
      width: '260mm',
      maxWidth: '100%',
      maxHeight: '98%',
      height: '98%',
      data: {
        patientMode: true,
        paymentId: paymentObj.PaymetnID,
        dataPatient: this.dataPatient,
        LOCID: paymentObj.LOCID,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.init();
      }

    }, err => {
    });
  }

}
